import { createClient } from '@supabase/supabase-js';
/**
 * Resolve Supabase connection settings from an env bag (e.g. `import.meta.env`).
 * Returns null when either var is missing so callers can fall back to
 * offline/sample data. Apps pass their own `import.meta.env`.
 */
export function readSupabaseEnv(env) {
    const url = env.VITE_SUPABASE_URL?.trim();
    const anonKey = env.VITE_SUPABASE_ANON_KEY?.trim();
    if (!url || !anonKey)
        return null;
    // Validate that the URL is actually a valid HTTP/HTTPS URL before passing to createClient.
    try {
        const parsed = new URL(url);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:')
            return null;
    }
    catch {
        return null;
    }
    return { url, anonKey };
}
/** Create a typed Supabase client. */
export function createOnitClient(env) {
    return createClient(env.url, env.anonKey, {
        auth: {
            persistSession: true,
            autoRefreshToken: true,
            detectSessionInUrl: true,
        },
    });
}
/**
 * Convenience: build a client from Vite env, or null when not configured.
 * Lets the dashboard render in a "not connected" state without throwing.
 */
export function createOnitClientFromEnv(env) {
    const config = readSupabaseEnv(env);
    if (!config)
        return null;
    try {
        return createOnitClient(config);
    }
    catch {
        // createClient can throw if the URL is malformed — treat as unconfigured.
        return null;
    }
}
//# sourceMappingURL=client.js.map